"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayFieldFactory = void 0;
const errors_1 = require("../errors");
function arrayFieldFactory(options) {
    if (!options.name) {
        throw new errors_1.FieldError('Field must have a name.');
    }
    if (!options.subField) {
        throw new errors_1.FieldError('Array field must have a subfield.');
    }
    function getDefault() {
        if (typeof options.defaultValue === 'function') {
            return (options.defaultValue());
        }
        if (options.defaultValue) {
            return options.defaultValue;
        }
        return undefined;
    }
    function validate(value) {
        if (!Array.isArray(value)) {
            throw new errors_1.ValidationError(`Field "${options.name}" must be an array`);
        }
        // Apply any subfield validators to each item
        value.forEach(subvalue => {
            options.subField.validate(subvalue);
        });
    }
    const applySubfieldToArray = (method) => (value) => {
        if (value === undefined) {
            return undefined;
        }
        return value.map(method);
    };
    const applySubfieldFromArray = (method) => (value) => {
        if (value === undefined || value === null) {
            return undefined;
        }
        return value.map(method);
    };
    return {
        name: options.name,
        isRequired: options.isRequired || false,
        getDefault,
        validate,
        fromDb: applySubfieldFromArray(options.subField.fromDb),
        fromApi: applySubfieldFromArray(options.subField.fromApi),
        toDb: applySubfieldToArray(options.subField.toDb),
        toApi: applySubfieldToArray(options.subField.toApi),
    };
}
exports.arrayFieldFactory = arrayFieldFactory;
//# sourceMappingURL=array.js.map